import {UAParser} from 'ua-parser-js'

export class Browser {
  private parser: UAParser;


  constructor(ua?: string) {
    this.parser = new UAParser(ua)
  }

  get os(): { name: string, version: string } {
    return this.parser.getOS()
  }

  get device(): { model: string, type: string, vendor: string } {
    return this.parser.getDevice()
  }

  get browser(): { name: string, version: string } {
    return this.parser.getBrowser()
  }

  get browserVersion() {
    let version = this.browser.version
    let intVersion = 0
    if(typeof version !== 'string' || version === '') {
      intVersion = 0
    } else {
      version = version.replace(/[^\d\.]/g,'').split(".")[0]
      intVersion = parseInt(version)
    }
    return intVersion
  }

  get isIOS(): boolean {
    return this.os.name === 'iOS' || ((/iPad|iPhone|iPod/.test(navigator.platform) ||
        (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) &&
        !window['MSStream'])
  }

  get isMac(): boolean {
    return this.os.name === 'Mac OS'
  }

  get isWin(): boolean {
    return this.os.name.toLowerCase() === 'windows'
  }

  get isChromeOS(): boolean {
    return this.os.name.toLowerCase() === 'chromium os'
  }

  get isMobile(): boolean {
    return this.device.type === 'mobile'
  }

  get isMeetMobile(): boolean {
    return this.isMobile || this.isPad || this.isAndroid || this.isIOS || this.isTablet
  }

  get isTablet(): boolean {
    if(this.isIOS){
       return !this.isMobile
    } else {
      if (!this.device.type && this.isAndroid) {
        return !this.isMobile
      } else {
        return this.device.type === 'tablet'  
      }
    }
  }

  get isAndroid(): boolean {
    return this.os.name === 'Android'
  }

  get isPad():boolean{

    return this.isIOS && !this.isMobile
  }

  get isFirefox(): boolean {
    return this.browser.name === 'Firefox'
  }

  get isEdge():boolean{
    return this.browser.name.toLowerCase() === 'edge'
  }

  get isOldEdge():boolean{
    return this.browser.name.toLowerCase() === 'edge'
        && this.browserVersion < 19
  }

  get isNewEdge():boolean{
    return this.browser.name.toLowerCase() === 'edge'
        && this.browserVersion > 77
  }

  get isSafari(): boolean {
    return this.browser.name === 'Safari'
  }

  get isMobileSafari(): boolean {
    return this.browser.name === 'Mobile Safari'
  }

  get isChrome(): boolean {
    return this.browser.name === 'Chrome' || this.browser.name === 'Electron'
  }

  get isIE (): boolean {
    return this.browser.name === 'IE'
  }

  get isMoxoAgent(): boolean {
    return /MoxoAgent/.test(navigator.userAgent)
  }

  get isMoxoAgentVDI(): boolean {
    return /MoxoAgentVDI/.test(navigator.userAgent)
  }

  get isTAEnv(): boolean {
    return /Cypress/.test(navigator.userAgent)
  }
  getOrigin(): string {
    let origin = location.origin;
    if (origin) {
      return origin
    } else {
      origin = location.protocol + "//" + location.hostname;
      if (location.port) {
        origin += ":" + location.port;
      }
      return origin;
    }
  }

  isSameDomain(backUrl, isRootDomainMatch?: boolean): boolean{
    let currentHost = location.host
    let aHref = document.createElement('a')
    aHref.href = backUrl
    if (isRootDomainMatch) {
      let temp = aHref.hostname.split('.').reverse()
      let tempCurrentHost = location.hostname.split('.').reverse()
      return tempCurrentHost[0] === temp[0] && tempCurrentHost[1] === temp[1]
    } else {
      return currentHost === aHref.hostname
    }
  }

  base64ToBlob (dataUrl) {
    const arr = dataUrl.split(',')
    const mime = arr[0].match(/:(.*?);/)[1]
    const bstr = atob(arr[1])
    let n = bstr.length
    const u8arr = new Uint8Array(n)
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n)
    }
    return new Blob([u8arr], { type: mime })
  }

  getURLParams (): Map<string,string> {
    let leadingTrail = '?'
    let queryString = window.location.search
    let query = new Map;
    let pairs = (queryString[0] === leadingTrail ? queryString.substr(1) : queryString).split('&');
    for (let i = 0; i < pairs.length; i++) {
      let pair = pairs[i].split('=');
      query.set(decodeURIComponent(pair[0]), decodeURIComponent(pair[1]) || '')
    }
    return query;
  }

  parseCookie (str) {
    if (str) {
      return str
        .split(';')
        .map(v => v.split('='))
        .reduce((acc, v) => {
          acc[decodeURIComponent(v[0].trim())] = decodeURIComponent(v[1].trim());
          return acc;
        }, {});
    } else {
      return {}
    }
  }

  get isBuiltinBrowser (): boolean{
    let ua = navigator.userAgent.toLowerCase()
    console.log(ua)
    if(/micromessenger/.test(ua) || /weibo/.test(ua) || /dingtalk/.test(ua) || /mqqbrowser/.test(ua)){
      return true
    }
    return false
  }

  getLocalLanguage () {
    let locale = (navigator?.languages && navigator.languages?.length ? navigator.languages[0] : (navigator.language || 'en-US')).toLowerCase()
    // process special case, as our server use 'en','es','fr','ja','pt','zh','zh-tw',
    // we should convert such as 'en-US' to 'en', 'fr-CA' to 'fr' etc.
    if (locale) {
      const items = locale.split('-')
      if (items[0] === 'zh') {
        // when only 'zh' or 'zh-CN', set locale to 'zh'
        // other cases, set locale to 'zh-tw'
        if (!items[1] || /cn/gi.test(items[1])) {
          locale = 'zh'
        } else {
          locale = 'zh-tw'
        }
      } else {
        locale = items[0]
      }
    }
    return locale
  }

  get isInIframe(): boolean {
    let parentWindow = window.parent;
    let inIframe = parentWindow && parentWindow !== window;
    if (inIframe) {
      if (this.isTAEnv && parentWindow === window.top) {
        //is cypress TA env then ignore
        return false
      }
    }
    return inIframe;
  }
}

const BrowserUtils = new Browser()
export {
  BrowserUtils
}
